export const buildQueryParams = (params: Record<string, string | number | boolean | undefined | null>): string => {
  return Object.entries(params)
    .filter(([_, value]) => value !== undefined && value !== null)
    .map(
      ([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`
    )
    .join('&')
}
